export const newItemWiseReportSubMenu = [{
  path: '/report/newItemWiseReport/list',
  component: () => import('@/views/report/new-item-wise-report/list.vue'),
  name: 'report.title',
  meta: {
    title: 'report.newItemWiseReport.title',
    roles: ['Super Admin', 'Admin', 'Read Only', 'Regional Manager', 'Invoice Manager', 'Zonal Manager', 'Unit Manager', 'Payment Manager'],
    noCache: true,
    hidden: false,
    icon: 'shopping'
  }
}];